import { makeStyles } from '@material-ui/core';
import {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import axios from 'axios';

import ContentTitle from '../General/contentTitle';
import various from '../General/various';
import imageIndex from '../img/imageIndex';
import Pagination from '../General/pagiNation';
import Footer from '../Footer/footer';
import { ogpGenerator } from '../ogp';
import { AuthContext } from '../auth';

const linkedSeminarText = (text) =>
  (text || '').split(/(https?:\/\/[^\s<>"']+)/g).map((part, index) =>
    /^https?:\/\//.test(part) ? (
      <a key={index} href={part}>{part}</a>
    ) : (
      part
    )
  );

const useStyles = makeStyles((theme) => ({
  contentTitle: {
    marginTop: '168px',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'baseline',
    '& > div': {
      marginBottom: '64px',
      lineHeight: '72px',
      '& > span': {
        '& > span': {
          '& > span': {
            lineHeight: '64px !important',
            textAlign: 'justify',
          },
        },
      },
    },
  },
  dateHash: {
    width: '100%',
    textAlign: 'start',
    fontWeight: 'bold',
    display: 'flex',
    flexFlow: 'column',
    gap: '16px 16px',
    marginBottom: '80px',
    borderBottom: 'solid 0.1px grey',
    '& > span': {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0px 16px',
      fontSize: '1rem',
      fontStyle: 'italic',
      lineHeight: '24px',
      marginBottom: '32px',
    },
    '& #share': {
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      '& > button': {
        display: 'block',
        width: '56px',
        '& > img': {
          color: '#000',
          minWidth: '16px',
        },
      },
    },
  },
  content: {
    // display: 'flex',
  },
  contentImage: {
    width: 'calc(70vw * 0.35)',
    marginRight: '24px',
    float: 'left',
    '& > a': {
      '& > img': {
        width: 'calc(70vw * 0.3)',
        height: 'calc(70vw * 0.3)',
        objectFit: 'contain',
        // filter:
        //   'contrast(100%) grayscale(100%) saturate(0%) drop-shadow(2px 2px 2px black)',
        border: 'solid 0.1px grey',
      },
    },
  },
  contentText: {
    width: '100%',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    lineHeight: '28px',
    fontSize: '1rem',
    textAlign: 'start',
    '& > span': {
      '& > a': {
        display: 'inline-block',
        '&:link': {
          color: '#000',
        },
        '&:visited': {
          color: '#000',
        },
        '&:hover': {
          color: theme.palette.primary.main,
        },
      },
    },
  },
  authText: {
    fontSize: '1rem',
    textAlign: 'start',
    '& > span': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
      fontWeight: 'bold',
      cursor: 'pointer',
    },
  },
}));

const NewsDetail = () => {
  const { isAuth } = useContext(AuthContext);
  const { contentElements = [] } = useOutletContext() || {};
  const ONE_PAGE_DISPLAY_CONTENTS = 1;
  const protocol = window.location.protocol;
  const domain = document.domain;

  const [, setPage] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [detail, setDetail] = useState();
  const [failedDetailId, setFailedDetailId] = useState();
  const [retryAttempt, setRetryAttempt] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const cls = useStyles();

  const ogp = useCallback((props) => {
    ogpGenerator(props);
  }, []);

  useLayoutEffect(() => {
    if (detail && detail.id === params.newsId) {
      const ogpProps = {
        page: 'news_detail',
        pageTitle: detail.title,
        path: location.pathname,
        imageUrl: detail.image,
      };
      ogp(ogpProps);
    }
  }, [detail, params.newsId, location, ogp]);

  useEffect(() => {
    let current = true;
    setDetail(undefined);
    setFailedDetailId(undefined);
    axios.get(`${various.currentDomain}api/news_detail/${params.newsId}/`)
      .then((res) => {
        if (current) {
          const obj = res.data.data;
          setDetail({
            id: obj.uuid,
            title: obj.title,
            date: obj.date,
            hash: obj.tags || [],
            contentText: obj.content,
            image: obj.news_image,
            isMembersOnly: obj.is_members_only,
            contentFormat: obj.content_format,
          });
        }
      })
      .catch(() => {
        if (current) setFailedDetailId(params.newsId);
      });
    return () => { current = false; };
  }, [params.newsId, retryAttempt]);

  const ids = contentElements.map((row) => row.id);
  const currentIndex = ids.indexOf(params.newsId);
  useEffect(() => {
    setForcePage(currentIndex >= 0 ? currentIndex : 0);
  }, [currentIndex]);

  const handleAuth = () => {
    navigate(various.general.login, {
      state: { previous: location.pathname },
    });
  };

  const renderContent = () => {
    const linkedContent = (text) => {
      // 参考：https://omkz.net/text-url-link/
      const regExp = /(https?:\/\/[\w/:%#$&?()~.=+-]+)/g;
      return text.replace(regExp, '<a href="$1">$1</a>');
    };
    // Detail belongs to the URL. The index only supplies pagination links.
    const body = detail && detail.id === params.newsId ? detail : null;
    if (!body) return null;
    const isSeminar = body.contentFormat === 'seminar_text';
    return (
      <div key={body.id}>
        <div className={cls.contentTitle}>
          <ContentTitle title={{ titleList: [body.title], sub: null }} />
        </div>
        <div className={cls.dateHash}>
          <div id="share">
            <FacebookShareButton
              url={
                protocol + '//' + domain + various.general.news + '/' + body.id
              }
              title={body.title}
            >
              <img src={imageIndex.newsPage.detail.fbIcon} alt="fb" />
            </FacebookShareButton>
            <TwitterShareButton
              url={
                protocol + '//' + domain + various.general.news + '/' + body.id
              }
              title={body.title}
              via="TOUZEN_"
              related={['TOUZEN_']}
              hashtags={body.hash.map((h) => h.slice(1))}
            >
              <img src={imageIndex.newsPage.detail.twIcon} alt="tw" />
            </TwitterShareButton>
          </div>
          <div>{body.date}</div>
          <span>
            {body.hash.map((h, i) => (
              <span key={i}>{h}</span>
            ))}
          </span>
        </div>
        {body.isMembersOnly && !isSeminar && !isAuth ? (
          <div className={cls.authText}>
            <span onClick={handleAuth}>こちら</span>
            からログインしてください。
          </div>
        ) : (
          <div className={cls.content}>
            <div
              id="target_nd_0"
              className={cls.contentImage}
            >
              <Link to={`${various.general.news}/${body.id}`}>
                <img src={body.image} alt="contentImage" />
              </Link>
            </div>
            <div className={cls.contentText}>
              {isSeminar ? <span>{linkedSeminarText(body.contentText)}</span> : <span
                dangerouslySetInnerHTML={{
                  __html: linkedContent(body.contentText || ''),
                }}
              />}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {renderContent()}
      {failedDetailId === params.newsId && (
        <div role="alert">
          ニュース本文を取得できませんでした。
          <button type="button" onClick={() => setRetryAttempt((attempt) => attempt + 1)}>
            再試行
          </button>
        </div>
      )}
      {currentIndex >= 0 && <Pagination
        contentsSize={contentElements.length}
        perPage={ONE_PAGE_DISPLAY_CONTENTS}
        setCurrentPageNumber={setPage}
        setForcePageNumber={setForcePage}
        forcePage={forcePage}
        ids={{ news: ids }}
      />}
      <Footer />
    </>
  );
};
export default NewsDetail;
